import React from 'react';
import LoadingDots from 'components/LoadingDots';

const InstructorsListLoader = () => (
  <div className="instructors-list__loader">
    <LoadingDots />
  </div>
);

export default InstructorsListLoader;
